import type { ReactElement } from 'react';
import { useCurrentUser } from '@hotjar/user';
import { Loader } from '@hotjar/hotsauce';
import { Page } from '@hotjar/webapp/components/Page';
import { navigateTo } from '@hotjar/webapp/utils/routing';
import { SITE } from '@hotjar/webapp/constants/routes';
import { useWindowTitle } from '@hotjar/webapp/hooks/useWindowTitle';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useAddOrganizationMutation } from './useAddOrganizationMutation';
import { AddOrganization } from './AddOrganization';

export function AddOrganizationPage(): ReactElement | null {
  const { data: currentUser } = useCurrentUser();
  const { t } = useTranslationWithPrefix('account:new-organization');
  useWindowTitle(t('title'));
  const isAccountAdmin = currentUser?.isAccountAdmin;

  const { mutation } = useAddOrganizationMutation(() => {
    navigateTo(SITE.LIST.path);
  });

  return (
    <Page>
      {/* until we get result from user endpoint let's a loader to prevent content blink */}
      <Loader isLoading={isAccountAdmin === undefined} size="xl">
        <AddOrganization
          addOrganization={(name) => mutation.mutate(name)}
          isLoading={mutation.isLoading}
          isAccountAdmin={!!isAccountAdmin}
        />
      </Loader>
    </Page>
  );
}
